<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-07 09:45:46
 * @LastEditors: yd
 * @LastEditTime: 2020-07-07 10:26:42
--> 
<template>
  <div>
    <hint></hint>
  </div>
</template>

<script>
import hint from './hint'
export default {
  components: { hint },
  props: {},
  data () {
    return {

    };
  },
  created () { },
  mounted () { },
  methods: {

  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
</style>
